import React from 'react';

import { Switch } from '@infoods/lifebase-ui';

import classNames from 'classnames';
import classes from './SubscriptionRow.module.scss';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { EntitySubscriptionInfo } from '../../../../interfaces/entitySubscription';
import {
  ChangeActivationStatus,
  ChangeDisplayToUserStatus,
} from '../ScanIqSubscriptionsManagement.settings';
import { BillingPeriodTypeChip } from '../../../../components/BillingPeriodTypeChip/BillingPeriodTypeChip';
import { SubscriptionPriceCell } from '../../../../components/SubscriptionPriceCell/SubscriptionPriceCell';
import {
  DescriptionOption,
  SubscriptionPriceCellWithDescription,
} from '../../../../components/SubscriptionPriceCellWithDescription/SubscriptionPriceCellWithDescription';
import { DisplayToUserStatusCell } from '../../../../components/DisplayToUserStatusCell/DisplayToUserStatusCell';

type SubscriptionRowProps = {
  subscription: EntitySubscriptionInfo;
  changeActivationStatus: ChangeActivationStatus;
  changeDisplayToUserStatus: ChangeDisplayToUserStatus;
};

const SubscriptionRow = ({
  subscription,
  changeActivationStatus,
  changeDisplayToUserStatus,
}: SubscriptionRowProps) => {
  const feesDescription: DescriptionOption[] = [
    { label: 'Stripe Fees', value: subscription.monthlyRenewalStripeFees },
  ];

  const {
    id,
    active,
    name,
    billingPeriodType,
    monthlyRenewalPrice,
    totalMonthlyRenewalPrice,
    totalMonthlyRenewalFees,
    displayToUser,
  } = subscription;

  return (
    <GridTableRow variant="subRow" className={classNames(classes.row, 'private-info')}>
      <GridTableCell justify="center">
        <Switch
          checked={active}
          onChange={(_event, checked) => changeActivationStatus(id, checked)}
        />
      </GridTableCell>
      <GridTableCell>{name}</GridTableCell>
      <GridTableCell>
        <BillingPeriodTypeChip billingPeriodType={billingPeriodType} />
      </GridTableCell>
      <SubscriptionPriceCell price={monthlyRenewalPrice} />
      <SubscriptionPriceCell price={totalMonthlyRenewalPrice} />
      <SubscriptionPriceCellWithDescription
        price={totalMonthlyRenewalFees}
        description={feesDescription}
      />
      <DisplayToUserStatusCell
        subscriptionId={id}
        displayToUser={displayToUser}
        active={active}
        onDisplayToUserStatusChange={changeDisplayToUserStatus}
      />
    </GridTableRow>
  );
};

export { SubscriptionRow };
